//@ts-nocheck
import React, { useState, useRef, useEffect, useMemo } from 'react'
import { Transforms } from 'slate'
import { useSlateStatic, ReactEditor, useSelected, useFocused } from 'slate-react'
import { cx } from '@emotion/css'
import { Registry } from '@react-registry'
import { Resizable } from 're-resizable'

import { cbModal, ActionTooltip, Icon, Tooltip } from '../../../../../../index'
import { FullscreenIcon } from '../../utils/Icon'
import { handleDelete } from '../../utils/actions'
//@ts-ignore
import styles from './style.module.css'
import { ImageEditModal } from './ImageEditModal'
import { ImageFullScreen } from './ImageFullScreen'
import { handleImageError } from '.'
import TooltipWithErrorBoundary from 'utils/components/TooltipErrorBoundary'
import './style.css'

const tooltipOffset: [number, number] = [0, -15];

export const ImageElement = ({ attributes, children, element, attrs, type, entry, ...props }) => {
  const containDivRef = useRef(null);
  const [boundaryEl, setBoundaryEl] = useState('viewport');

  const selected = useSelected()
  const focused = useFocused()
  const editor = useSlateStatic()
  // TODO: textAlign to text-align
  const alignment = attrs?.style?.["textAlign"] || attrs?.style?.["text-align"]
  const imgRef = useRef(null)
  const parentRef = useRef(null)
  // const [maxWidth, setMaxWidth] = useState(null)
  const imageSizeInputEnabled = editor?.imageSizeInputEnabled;


  let isInline = (element?.attrs?.inline || element?.attrs?.["redactor-attributes"]?.inline) ? true : false


  const onResizeStop = (event, dir, el, size) => {
    let path = ReactEditor.findPath(editor, element)
    let { attrs } = element
    let width = imgRef.current.clientWidth
    const newAttrs = { ...attrs };

    newAttrs['width'] = width;
    const newStyles = { ...newAttrs.style }
    newAttrs.style = { ...newStyles }
    newAttrs.style['max-width'] = `${width}px`
    newAttrs.style['width'] = `${width}px`
    newAttrs['max-width'] = `${width}`
    newAttrs['width'] = `${width}`

    if (imageSizeInputEnabled) {
      let height = imgRef.current.clientHeight
      newAttrs['height'] = height;
      newAttrs.style['height'] = `${height}px`
    }

    Transforms.setNodes(
      editor,
      { attrs: { ...newAttrs } },
      {
        at: path
      }
    )
  }


  const onResize = (event, dir, el, size) => {
    let width = imgRef.current.clientWidth
    if (attributes?.ref?.current) {
      attributes.ref.current.setAttribute('width', width)
      attributes.ref.current.setAttribute('max-width', width)
      attributes.ref.current.style.width = `${width}px`;
      attributes.ref.current.style.maxWidth = `${width}px`;

      if (imageSizeInputEnabled) {
        let height = imgRef.current.clientHeight
        attributes.ref.current.setAttribute('height', height)
        attributes.ref.current.style.height = `${height}px`;
      }
    }
  }

  useEffect(() => {
    if (containDivRef.current) {
      const closestBoundary = containDivRef.current.closest('#scrte-editable');
      setBoundaryEl(closestBoundary || 'viewport');
    }
  }, []);

  const popperOptions = {
    modifiers: [
      {
        name: 'preventOverflow',
        options: {
          boundary: boundaryEl
        }
      }
    ],
  }

  let alignmentStyle
  if (alignment) {
    delete attrs.style['float']
    const marginAlignment = {
      center: { margin: 'auto' },
      left: { marginRight: 'auto' },
      right: { marginLeft: 'auto' }
    }
    alignmentStyle = marginAlignment[alignment]
  }

  /* istanbul ignore if */
  if (isInline) {
    alignmentStyle = { display: "inline-block", margin: "0 0.15rem -1px" }
    if (alignment) {
      alignmentStyle.float = alignment
    }
  } else {
    alignmentStyle = { ...alignmentStyle, display: 'block' }
  }

  alignmentStyle = isInline
    ?
    { ...alignmentStyle }
    : alignmentStyle

  const toolList = [
    {
      label: <Icon version='v2' id='edit' icon="Fullscreen" size="small" />,
      testId: 'cs-element-image-fullscreen',
      title: 'Fullscreen',
      action: () => {
        editor.setFullScreen();
        cbModal({
          component: (props) => <ImageFullScreen url={type === 'asset' ? entry?.['asset-link'] : element?.attrs?.url} {...props} />
        })
      }
    },
    {
      label: <Icon version='v2' id='edit' icon="ImageSettings" size="small" />,
      testId: 'cs-element-image-edit',
      title: 'Edit',
      action: () => {
        editor.setFullScreen();
        let modalProps = {
          customClass: 'scrte--image-edit-modal',
        }
        if (imageSizeInputEnabled) {
          modalProps = {
            size: 'customSize',
            customClass: 'scrte--image-edit-modal-big',
          }
        }
        cbModal({
          component: (props) => <ImageEditModal imageSizeInputEnabled={imageSizeInputEnabled} type={type} element={element} editor={editor} {...props} />,
          modalProps
        })
      }
    },
    {
      label: <Icon version='v2' id='delete' icon="Delete" size="small" />,
      testId: 'cs-element-image-delete',
      title: 'Delete',
      action: () => {
        handleDelete(editor, element)
      }
    }
  ]
  /* istanbul ignore if */
  if (type === 'asset') {
    toolList.unshift(
      {
        label: <Icon icon='View' size='small' />,
        title: 'View',
        action: () => {
          const { history, apiKey } = editor?.['requestProps'] || {};
          const currentBranch = editor?.requestProps?.branch
          const assetUid = attrs?.['asset-uid'];
          if (!history || !apiKey) return;
          history.push({
            pathname: `/stack/${apiKey}/assets/${assetUid}`,
            search: currentBranch ? `branch=${currentBranch}` : ''
          })
        }
      }
    )
  }

  return (
    <span {...attributes} {...attrs} data-type="img" ref={containDivRef} style={{ ...attrs.style, ...alignmentStyle }} data-testid={'image-wrapper'}>
      <TooltipWithErrorBoundary
        zIndex={909}
        className="p-0"
        variantType="light"
        appendTo={document.body}
        offset={tooltipOffset}
        position="bottom"
        popperOptions={popperOptions}
        content={
          <div contentEditable={false} className={styles['scrte--action-tooltip']}>
            {
              toolList.map((item) => {
                return (
                  <button data-testid={`cs-${item.title}`}
                    data-test-id={item.testId}
                    id={item.title}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      item.action(e);
                    }}>
                    {item.label}
                  </button>
                )
              })
            }
          </div>
        }
      >
        <span
          data-testid={'image-parent-ref'}
          ref={parentRef}
          contentEditable={false}
          style={{
            paddingTop: '3px',
            paddingBottom: '3px',
            display: `${isInline ? 'block' : 'flow-root'}`,
          }}>
          <Resizable
            onResize={onResize}
            onResizeStop={onResizeStop}
            lockAspectRatio={false}
            size={{
              width: `${element.attrs.width ? element.attrs.width + "px" : 'auto'}`,
              height: `${imageSizeInputEnabled && element.attrs.height ? element.attrs.height + "px" : 'auto'}`
            }}
            // maxWidth={maxWidth}
            className={cx(styles['scrte--img-container'], {
              [styles['scrte--img-inline']]: Boolean(isInline)
            })}
            handleStyles={{
              right: { right: 0, width: '15px' },
              left: { left: 0, width: '15px' },
              bottom: { bottom: '5px' },
              bottomLeft: { left: '-10px', bottom: '-5px' },
              bottomRight: { bottom: '-5px', right: '-10px' }
            }}
            handleWrapperClass="test2"
            minWidth={imageSizeInputEnabled ? 15 : 165}
          // enable={{ top: !isInline, right: !isInline, bottom: !isInline, left: !isInline, topRight: !isInline, bottomRight: !isInline, bottomLeft: !isInline, topLeft: !isInline }}
          >
            <div ref={imgRef} style={{ width: '100%', height: '100%' }}>
              <img
                id="image"
                src={type === 'asset' ? entry['url'] : element.attrs.url}
                onError={handleImageError}
                className={cx(styles['scrte-img'], {
                  [styles['scrte--img-selected']]: Boolean(selected && focused)
                })}
                alt={element.attrs.alt}
                data-testid={'scrte-image'}
              />
              <span contentEditable={false} className={styles['scrte-image-resizer-feedback-left']}>
                <span
                  contentEditable={false}
                  className={styles['scrte-image-resizer-feedback']}></span>
              </span>
              <span contentEditable={false} className={styles['scrte-image-resizer-feedback-right']}>
                <span
                  contentEditable={false}
                  className={styles['scrte-image-resizer-feedback']}></span>
              </span>
            </div>
            {element?.attrs?.caption && (
              <p className={styles['scrte--caption']}>{element.attrs.caption}</p>
            )}
          </Resizable>
        </span>
      </TooltipWithErrorBoundary>
      {children}
    </span>
  )
}

const beforeElementRender = (props) => {
  if (props?.element?.attrs?.inline || props?.element?.attrs?.style?.float === 'right' || props?.element?.attrs?.style?.float === 'left') {
    props.DisableDND = true
    props.DisableSelectionHalo = true
  }
}
Registry.register(
  {
    Component: ImageElement,
    //iconName: 'ri-image-line',
    title: 'Image',
    subtitle: 'Add beautiful images',
    toolbar: {
      inMainToolbar: false,
      inHoveringToolbar: false
    },
    beforeElementRender: beforeElementRender
  },
  { id: 'img', registry: 'v2.element' }
)


